'use strict'
module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/semver/~/yallist/iterator.js
// module id = 2463
// module chunks = 0